import { http, HttpHandler, HttpResponse } from 'msw';

import { AutocompleteResponse } from '../../../domain/address';

export const autocompleteResponse: AutocompleteResponse = {
  suggestions: [
    {
      secondary: 'Apt',
      state: 'NY',
      entries: 5,
      city: 'New York',
      street_line: '123 1/2 Chrystie St',
      zipcode: '10002',
    },
    {
      secondary: 'Frnt A',
      state: 'NY',
      entries: 1,
      city: 'New York',
      street_line: '123 1/2 Chrystie St',
      zipcode: '10002',
    },
    {
      secondary: '',
      state: 'NY',
      entries: 0,
      city: 'New York',
      street_line: '123 1/2 Chrystie St',
      zipcode: '10002',
    },
    {
      secondary: '# 1',
      state: 'NY',
      entries: 1,
      city: 'New York',
      street_line: '123 1st Ave',
      zipcode: '10003',
    },
    {
      secondary: '',
      state: 'NY',
      entries: 0,
      city: 'New York',
      street_line: '123 1st Ave',
      zipcode: '10003',
    },
    {
      secondary: 'Apt',
      state: 'NY',
      entries: 6,
      city: 'New York',
      street_line: '123 2nd Ave',
      zipcode: '10003',
    },
    {
      secondary: 'Frnt',
      state: 'NY',
      entries: 2,
      city: 'New York',
      street_line: '123 2nd Ave',
      zipcode: '10003',
    },
    {
      secondary: '',
      state: 'NY',
      entries: 0,
      city: 'New York',
      street_line: '123 2nd Ave',
      zipcode: '10003',
    },
    {
      secondary: 'Apt',
      state: 'NY',
      entries: 47,
      city: 'New York',
      street_line: '123 3rd Ave',
      zipcode: '10003',
    },
    {
      secondary: 'Frnt 1',
      state: 'NY',
      entries: 1,
      city: 'New York',
      street_line: '123 3rd Ave',
      zipcode: '10003',
    },
  ],
};

const handlers: HttpHandler[] = [
  http.post<never, never, AutocompleteResponse>('/qualification/street_address/autocomplete', () => {
    return HttpResponse.json(autocompleteResponse);
  }),
];

export { handlers };
